import { render, staticRenderFns } from "./SoldDealRecap.vue?vue&type=template&id=1ee65d5a&scoped=true"
import script from "./SoldDealRecap.vue?vue&type=script&lang=js"
export * from "./SoldDealRecap.vue?vue&type=script&lang=js"
import style0 from "./SoldDealRecap.vue?vue&type=style&index=0&id=1ee65d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee65d5a",
  null
  
)

export default component.exports